<template>
<div class="col-12 px-0"> 
    <el-table
        :data="tableData"
        ref="multipleTable"
        style="width: 100%"
        id="table-sponsor-partner"
        :class="getPrimaryColor"
    >

        <el-table-column prop="name" sortable :sort-method="sortColumnName" label="financiador" min-width="80">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <NameInitials :name="scope.row.name" small/>
                    <el-tooltip class="item" :content="scope.row.name | formatName" placement="top">
                        <span class="break-name c-ndarkfour medium">
                            {{ (scope.row.tradingName || scope.row.name) | formatName }}
                        </span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>

        <el-table-column prop="sponsor" sortable :sort-method="sortColumnCnpj" label="cnpj" min-width="60">
            <template slot-scope="scope">
                <span class="c-ndarkfour medium">
                    {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="main" sortable :sort-method="sortColumnCnpj" label="fundo" min-width="60">
            <template slot-scope="scope">
                <span class="c-ndarkfour medium">
                    <div class="d-flex">
                        <caption class="mb-0 c-ndarkfour bgc-nlightone main-status">
                            {{ mainStatusText(scope.row.sponsorPartners.main) }}
                        </caption>
                    </div>
                </span>
            </template>
        </el-table-column>

        <el-table-column prop="orderFomentationRequest" min-width="120">
            <template slot-scope="scope">
                 <div class="d-flex justify-content-end align-items-center">
                    <el-dropdown trigger="click">
                        <Button size="small" :color="getPrimaryColor">Ações</Button>
                        <el-dropdown-menu slot="dropdown">
                            <ActionBtnItemsContainer :withoutBottomLine="false">
                                <el-dropdown-item>
                                    <span 
                                        :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-3 d-flex align-items-center`" 
                                        @click="goToDetails(scope.row)"
                                    >
                                        <Edit class="mr-2" />Editar dados
                                     </span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span 
                                        :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-3 d-flex align-items-center`"  
                                        @click="goToUsers(scope.row)"
                                    >
                                            <Users size="16" color="#A1A8B8" class="mr-2" />Gerenciar usuários
                                    </span>
                                </el-dropdown-item>
                            </ActionBtnItemsContainer>
                            <ActionBtnItemsContainer :withoutBottomLine="true">
                                <el-dropdown-item>
                                    <span   
                                        :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-3 d-flex align-items-center`"
                                        @click="goToRules(scope.row)"
                                    >
                                        <Settings class="mr-2"/>Regras da operação
                                    </span>
                                </el-dropdown-item>
                            </ActionBtnItemsContainer>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <BuyerProviderGroupDelete :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @delete="requestDelete"/>
</div>
</template>

<script>
import BuyerProviderGroupDelete from '@/components/modals/BuyerProviderGroupDelete'
import NameInitials from '@/components/icons/NameInitials'
import deleteBuyerEconomicGroup from '@/api/deleteBuyerEconomicGroup'
import getCompany from '../../api/getCompany'
import ActionBtnItemsContainer from '../container/ActionBtnItemsContainer.vue'
import Users from '../icons/Users.vue'
import Edit from '../icons/Edit.vue'
import Settings from '../icons/Settings.vue'

export default {
    props: {
        tableData: {
            required: true
        },
    },
    components: {
        BuyerProviderGroupDelete,
        NameInitials,
        ActionBtnItemsContainer,
        Users,
        Edit,
        Settings,

    },
    data() {
        return {
            dialogVisible: false,
            buyerIdToDelete: ''
        }
    },
    methods: {
        mainStatusText(status) {
            return status ? 'Principal' : 'Secundário'
        },
        async goToDetails(row) {
            await getCompany({ cnpjId: row.cnpjId, companyType: '0' })

            this.$router.push(`/sponsor/update/${row.cnpjId}/0`)
        },
        async goToUsers(row) {
            await getCompany({ cnpjId: row.cnpjId, companyType: '0' })

            this.$router.push(`/user/company/${row.cnpjId}`)
        },
        async goToRules(row) {
            await getCompany({ cnpjId: row.cnpjId, companyType: '0' })

            if(row.sponsorPartners.main) {
                this.$router.push(`/partners/${this.$route.params.partnerId}/sponsor/${row.cnpjId}/rules`)
            } else {
                this.$router.push(`/partners/${this.$route.params.partnerId}/sponsor/${row.cnpjId}/secondary/rules`)
            }
        },
        sortColumnCnpj(a, b) {
            return parseInt(a.cnpj.cnpj) - parseInt(b.cnpj.cnpj)
        },
        sortColumnStatus(a, b) {
            return a.cnpj.registerComplete - b.cnpj.registerComplete
        },
        sortColumnName(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        },
        handleDeleteBuyer(id) {
            this.dialogVisible = true
            this.buyerIdToDelete = id
        },
        async requestDelete() {
            const result = await deleteBuyerEconomicGroup(this.$route.params.groupId, { buyerIds: [this.buyerIdToDelete]})
            if (result.data.ok) {
                this.$emit('buyerDeleted')
            }
            this.dialogVisible = false
        }
    },
}
</script>

<style lang="scss" scoped>
.el-table .el-table__body-wrapper .el-table__body tbody .el-table__row td .cell .el-dropdown {
    text-align: end !important;
}

.main-status {
    padding: 4px 8px;
    border-radius: 26px;
}
</style>